import { hexToRgb } from 'utils/colorHelpers'
import Styles from './HexCodeDisplayer.module.scss'
import { Pill } from 'components/Pill/Pill'

interface HexCodeDisplayerProps {
  hex: string
}

export const HexCodeDisplayer = ({ hex }: HexCodeDisplayerProps) => {
  const rgb = hexToRgb(hex)
  if (!rgb) return <>{hex}</>

  return (
    <Pill className={Styles.pill}>
      <span role="presentation" className={Styles.swatch} style={{ backgroundColor: hex }} />
      <span className={Styles.hexText} style={{ color: hex }}>
        {hex.toLowerCase()}
      </span>
    </Pill>
  )
}
